var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoaded)?_c('loading-overlay',{staticClass:"loading-list",attrs:{"state":!_vm.isLoaded}}):_vm._e(),(_vm.isLoaded)?_c('div',{staticClass:"edit-form"},[_c('create-job-opening',{attrs:{"form":_vm.job}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }